import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { ThemeProps } from '@theme/base';
import { TestId } from '@components/test-ids';
import { useI18NextContext } from '@components/hooks';
import { SectionTitle } from '@components/common/section-title';
import { FacebookWidget } from './FacebookWidget';

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div(({ theme }: ThemeProps) => ({
  alignItems: 'center',
  backgroundColor: theme.custom.colors.group10.lighter,
  borderRadius: 10,
  paddingLeft: theme.custom.spacing.medium,
  paddingRight: theme.custom.spacing.medium,
  paddingBottom: theme.custom.spacing.xxxLarge,
  paddingTop: theme.custom.spacing.xxxLarge,
  width: '100%'
}));

const InnerContainer = styled.div({
  margin: 'auto',
  width: '100%',
  maxWidth: 500
});

const Subtitle = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any)
}));

const StyledWidget = styled(FacebookWidget)(({ theme }: ThemeProps) => ({
  border: `10px solid ${theme.custom.colors.white}`,
  borderRadius: 10,
  boxSizing: 'content-box',
  height: 750
}));

/* *********************** *
 *    FacebookWidget    *
 * *********************** */

const FB_PAGE_HREF = 'https://www.facebook.com/mercuryagents';

export const FacebookWrapperComponent = () => {
  const t: any = useI18NextContext();

  return (
    <Container data-testid={TestId.facebookWrapper.main}>
      <InnerContainer>
        <SectionTitle heading={t('agent__page--follow-facebook-title')} />
        <Subtitle>{t('agent__page--follow-facebook-subtitle')}</Subtitle>
        <StyledWidget linkText={t('agent__page--mercury-agents')} href={FB_PAGE_HREF} />
      </InnerContainer>
    </Container>
  );
};

export const FacebookWrapper = withTheme(FacebookWrapperComponent);
